export default "__VITE_ASSET__CdEAgSTD__"